/* global gdAlertify */
import React, { useState, useEffect } from "react";
import axiosInstance from "../config/axiosConfig"; // Asegúrate de tener tu configuración de axios
import BuscarPaciente from "./components/BuscarPaciente";
import { formatDate } from "../utils/utils";

const DocumentosPacientes = () => {
    const [pacienteInfo, setPacienteInfo] = useState(null);
    const [documentos, setDocumentos] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [detalleArchivo, setDetalleArchivo] = useState("");

    const handleSeleccionaPaciente = async (paciente) => {
        setPacienteInfo(paciente);
        if (paciente) {
            try {
                const response = await axiosInstance.get(`/paciente/documentos/lista/${paciente.id}`);
                setDocumentos(response.data.data);
            } catch (error) {
                console.error("Error al obtener los documentos:", error);
                gdAlertify.notiError("Error al obtener los documentos. Intenta nuevamente.");
            }
        } else {
            setDocumentos([]);
        }
    };

    const handleFileChange = (e) => {
        setSelectedFile(e.target.files[0]);
    };

    const handleDetalleChange = (e) => {
        setDetalleArchivo(e.target.value);
    };

    const handleUploadFile = async () => {
        if (!selectedFile || !pacienteInfo) {
            gdAlertify.notiError("Por favor selecciona un archivo y un paciente.");
            return;
        }
        if (!detalleArchivo.trim()) {
            gdAlertify.notiError("Por favor agrega un detalle para el archivo.");
            return;
        }

        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("detalle", detalleArchivo);
        formData.append("pacienteID", pacienteInfo.id);
        gdAlertify.confirm({
            title: 'Registrar documento',
            message: '¿Está seguro de registrar documento?',
            onConfirm: async () => {
                try {
                    const response = await axiosInstance.post("/paciente/documentos/guardar", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    });
                    const response2 = await axiosInstance.get(`/paciente/documentos/lista/${pacienteInfo.id}`);
                    setDocumentos(response2.data.data);
                    setSelectedFile(null);
                    setDetalleArchivo("");
                    gdAlertify.notiSuccess("Archivo cargado exitosamente.");
                } catch (error) {
                    console.error("Error al cargar el archivo:", error);
                    gdAlertify.notiError("Error al cargar el archivo. Intenta nuevamente.");
                }
            },
            onCancel: () => {
                gdAlertify.notify('Envío cancelado', 'error');
            }
        });
    };

    const handleViewDocument = (documentId) => {
        let file = documentos.find(doc => doc.documentoID === documentId)
        console.log(documentId);
        console.log(file);
        window.open(file.archivoURL, "_blank"); // '_blank' abre la URL en una nueva pestaña
    };

    const handleDeleteDocument = async (documentId) => {
        gdAlertify.confirm({
            title: 'Eliminar documento',
            message: '¿Está seguro de eliminar documento?',
            onConfirm: async () => {
                try {
                    await axiosInstance.post(`/paciente/documentos/eliminar/${documentId}`);
                    const response2 = await axiosInstance.get(`/paciente/documentos/lista/${pacienteInfo.id}`);
                    setDocumentos(response2.data.data);
                    gdAlertify.notiSuccess("Documento eliminado exitosamente.");
                } catch (error) {
                    console.error("Error al eliminar el documento:", error);
                    gdAlertify.notiError("Error al eliminar el documento. Intenta nuevamente.");
                }
            },
            onCancel: () => {
                gdAlertify.notify('Envío cancelado', 'error');
            }
        });
    };

    return (
        <div className="container mt-5">
            <div className="card p-4">
                <h1 className="mb-4">Repositorio de documentos</h1>
                <div className="mb-3">
                    <div className="row">
                        <div className="border p-4 mb-4">
                            <div className="row g-3 d-flex justify-content-between">
                                <div className="col-md-12">
                                    <BuscarPaciente onSelect={handleSeleccionaPaciente} conPaciente={true} />
                                </div>
                            </div>
                        </div>
                        <div className="border p-4 mb-4">
                            <div className="col-md-12">
                                <label className="form-label fw-bold">Paciente</label>
                                <p id="nombrePaciente" className="form-control-plaintext">
                                    {pacienteInfo
                                        ? `${pacienteInfo.nombres} ${pacienteInfo.apellidoPaterno} ${pacienteInfo.apellidoMaterno}`
                                        : ""}
                                </p>
                            </div>
                        </div>

                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <div className="input-group">
                                <input
                                    type="file"
                                    className="form-control"
                                    id="fileInput"
                                    onChange={handleFileChange}
                                    style={{ display: "none" }}
                                />
                                <label
                                    htmlFor="fileInput"
                                    className="btn btn-outline-primary d-flex align-items-center"
                                    style={{ cursor: "pointer", padding: "8px 20px", borderRadius: "5px" }}
                                >
                                    Seleccionar archivo
                                </label>
                                {selectedFile && (
                                    <span className="ms-3 text-muted" style={{ fontSize: "14px" }}>
                                        {selectedFile.name}
                                    </span>
                                )}
                            </div>
                            <input
                                type="text"
                                className="form-control ms-3"
                                placeholder="Detalle del archivo"
                                value={detalleArchivo}
                                onChange={handleDetalleChange}
                                style={{ maxWidth: "300px" }}
                            />
                            <button
                                className="btn btn-primary ms-3"
                                style={{ padding: "8px 20px", borderRadius: "5px" }}
                                onClick={handleUploadFile}
                            >
                                Cargar
                            </button>
                        </div>

                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th>Nombre de Documento</th>
                                    <th>Detalle</th>
                                    <th>Fecha de Carga</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {documentos.length > 0 ? (
                                    documentos.map((doc) => (
                                        <tr key={doc.documentoID}>
                                            <td>{doc.nombre}</td>
                                            <td>{doc.detalle}</td>
                                            <td>{formatDate(doc.fechaCarga)}</td>
                                            <td>
                                                <button
                                                    className="btn btn-info me-2"
                                                    onClick={() => handleViewDocument(doc.documentoID)}
                                                >
                                                    Ver
                                                </button>
                                                <button
                                                    className="btn btn-danger"
                                                    onClick={() => handleDeleteDocument(doc.documentoID)}
                                                >
                                                    Eliminar
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="4" className="text-center">
                                            No hay documentos disponibles
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DocumentosPacientes;
